import { InputSelect } from '@lmc/ui-kit'
import useGoalsAccess from 'components/AccessControl/features/useGoalsAccess'
import useGoals from 'screens/Residents/screens/ResidentsGoalsScreen/components/useGoals/useGoals'
import styled from 'styled-components'

type LogsGoalsSelectProps = {
  onChange: (value: unknown) => void
  residentID: string
  testId?: string
}

const LogsGoalsSelect = ({
  onChange,
  residentID,
  testId
}: LogsGoalsSelectProps) => {
  const hasGoals = useGoalsAccess()
  const { goals, isLoading } = useGoals(residentID)

  return (
    hasGoals && (
      <Wrapper data-testid={testId || 'logs-goals-select'}>
        <InputSelect
          testId={testId ? `${testId}-goals-select` : 'logs-goals-select-input'}
          mode="multiple"
          placeholder="Add goals"
          onChange={onChange}
          options={
            goals?.map((goal) => ({
              label: goal?.title || 'N/A',
              value: goal?.id
            })) || []
          }
          isLoading={isLoading}
          data-testid={
            testId ? `${testId}-input-select` : 'logs-goals-select-input-select'
          }
        />
      </Wrapper>
    )
  )
}

const Wrapper = styled.div`
  max-width: 400px;
  margin: 0px auto;
  margin-bottom: 15px;
`

export default LogsGoalsSelect
